import React from "react";
import { BtnText } from '@saladbob/sassafras'

type Props = {
    children?: React.ReactNode;
    [key: string]: any;
};

const AltBtn: React.FC<Props> = ({ children, ...props }) => {
    return (
        <BtnText
            type="button"
            txtColor="neutral"
            {...props}
        >
            {children}
        </BtnText>
    );
}

export default AltBtn;